module.exports = __webpack_public_path__ + "images/emoji/massage.9bb103ec4286cab1b77b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/massage.png
// module id = wLQK
// module chunks = 13